import type { ComponentProps } from 'react';

import CopyButton from '@/components/atoms/CopyButton/CopyButton';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

type JsonTextareaProps = Omit<ComponentProps<typeof Textarea>, 'value'> & { value?: string };

export const JsonTextarea = ({ className, value, ...props }: JsonTextareaProps) => (
  <div className="relative">
    <div
      role="presentation"
      onMouseDown={(event) => event.preventDefault()}
      className="absolute top-2 right-2 z-10"
    >
      <CopyButton data={value ?? ''} iconSize={16} />
    </div>
    <Textarea
      spellCheck={false}
      {...props}
      value={value}
      className={cn('min-h-48 resize-y pr-10 font-mono text-xs leading-5', className)}
    />
  </div>
);
